<template>
<div class="col-12 mb-2">
  <b-button variant="success" v-b-modal.addProfile>Add Profile</b-button>
  <b-modal
    size="sm"
    id="addProfile"
    ref="modal"
    title="AddProfile"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group label="Name" label-for="name">
        <b-form-input id="name" v-model="newProfileName" :state="newProfileNameState" required></b-form-input>
      </b-form-group>

      <b-form-group label="Enable TG Alert" label-for="isTgAlert">
        <b-form-select id="isTgAlert" v-model="isTgAlert" :options="options" required></b-form-select>
      </b-form-group>

      <b-form-group  v-show="isTgAlert" label="TG Alert Interval (seconds)" label-for="tgInterval">
        <b-form-input type="number" id="tgInterval" v-model.number="tgInterval" step="10" min="10" max="3600" ></b-form-input>
      </b-form-group>
      
    </form>
  </b-modal>
</div>
</template>

<script>
    export default {
        name: 'AddProfile',
        props: [],
        components: {
        },
        data() {
          return {
            state: false,
            validMsg: "Name is required",
            newProfileName: '',
            isTgAlert: 0,
            tgInterval: 10,
            newProfileNameState: false,
            newProfileNameValidMsg: "Name is required",
            options: [
              { value: 0, text: 'False' },
              { value: 1, text: 'True' }
            ]

          }
        },
        mounted() {
        },
        methods: {
          checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.newProfileNameState = valid
            return valid
          },
          resetModal() {
            this.newProfileName = '';
            this.isTgAlert = 0;
            this.tgInterval = 10;
            this.newProfileNameState = null;
            this.newProfileNameValidMsg = '';

          },
          handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
          },
          handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
              return
            }
            this.$emit('add', {newProfileName: this.newProfileName, isTgAlert: this.isTgAlert, tgInterval: this.tgInterval});
            // Hide the modal manually
            this.$nextTick(() => {
              this.$bvModal.hide('addProfile')
            })
          },
        },
    }
</script>